import { ToolTip } from '../ToolTip/ToolTip';
export const SingleLineInput = (props)=>{
    const {toolTipInfo,setState,placeholder,title,id} = props
    return(<div className="inputGroup">
    <div>
        <div className="label"  >{title}</div>
       <ToolTip toolTipInfo={toolTipInfo}/>
    </div>
    <input type="text" id={id} onInput={(e)=>setState(e.target.value)} placeholder={placeholder}></input>
</div>)
}